import './pdf-overview-screen.scss'

import { defineComponent, PropType } from 'vue'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

import { ArchiveResource, ConditionReport, SpecimenResource, Wemi } from '@skinsoft/types'
import { conditionReportSelectors } from '@skinsoft/selectors'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { PDFViewer } from '@skinsoft/ui'
import { CLOSE_PDF_OVERVIEW_TOPIC } from '../../busTopics'
import { PDFProgressBar } from './pdf-progress-bar'
import { DISPLAY_ALERT_TOPIC, FREE_MEDIA_CACHE_TOPIC } from '@skinsoft/bus/src/busTopics'

export const PDFOverviewScreen = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sPdfProgressBar: PDFProgressBar,
        sPdfViewer: PDFViewer,
    },
    props: {
        conditionReport: {
            type: Object as PropType<ConditionReport>,
            required: true,
        },
        associatedEntity: {
            type: Object as PropType<Wemi | ArchiveResource | SpecimenResource>,
            required: true,
        },
    },
    template: require('./pdf-overview-screen.html'),
    data() {
        return {
            pdfFile: null as any,
            pdfFileUrl: "",
            pdfReady: false,
            backIcon: faArrowLeft,
        }
    },
    computed: {
        fileName() {
            return `${conditionReportSelectors.referenceNumber(this.conditionReport)}.pdf`
        },
    },
    methods: {
        closePdfOverviewScreen() {
            this.emitOnBus(CLOSE_PDF_OVERVIEW_TOPIC)
        },
        onFileUploaded(event) {
            this.pdfFile = event.target.files[0]
        },
    },
    watch: {
        // Bug: 'searchFeatured' is not a prop or data field on this component, so this watcher never
        // fires on change (only once, via immediate) — needs a real field to watch.
        searchFeatured: {
            async handler() {
                this.emitOnBus(FREE_MEDIA_CACHE_TOPIC)
                await new Promise<void>(r => setTimeout(r, 0))
                this.$conditionReportPDFGenerator.generatePDF(
                    this.conditionReport,
                    this.associatedEntity,
                    (blob) => {
                        this.pdfReady = true;
                        this.pdfFile = blob
                        this.pdfFileUrl = window.URL.createObjectURL(blob)
                    },
                    this.$i18n?.locale,
                    undefined,
                    true
                )
                .catch(e => {
                    const alertPayload = {
                        message: this.$t('pdfDocument.generationFailureAlert'),
                        variant: 'danger'
                    };
                    this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
                })
            },
            immediate: true,
        },
    },
})
